import EmptyState from '../../common/EmptyState.jsx';
import ProductCard from './ProductCard.jsx';

export default function ProductGrid({ products = [], emptyTitle = 'No products found', className = '' }) {
  if (!products.length) {
    return <EmptyState title={emptyTitle} text="Try another category or search term." />;
  }

  return (
    <div className={`product-grid-react ${className}`.trim()}>
      {products.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
}
